import React from 'react';
import { Link } from 'react-router-dom';
import { getStatus, isLeavingSoon, statusLabel } from '../../utils/exhibition';
import { getProductsByCreator } from '../../utils/catalog';
import type { Creator } from '../../types/catalog';
import { ExhibitionProgress } from './ExhibitionProgress';
export function CreatorCard({
  creator
}: {
  creator: Creator;
}) {
  const status = getStatus(creator);
  const pieces = getProductsByCreator(creator.id).length;
  const leaving = isLeavingSoon(creator);
  return <Link to={`/createurs/${creator.id}`} className="group flex h-full flex-col" data-id="element-229" data-mp="2nq7eife2insk">
      <div className="relative aspect-[3/4] overflow-hidden rounded-sm bg-shell" data-id="element-230" data-mp="2sh5ufdv59jva">
        <img src={creator.image} alt={`Univers de ${creator.name}`} loading="lazy" className={`h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03] ${status === 'past' ? 'grayscale-[60%]' : ''}`} data-id="element-231" data-mp="2xgsh0dwv4cgr" />
        {status === 'upcoming' && <span className="absolute left-3 top-3 rounded-full bg-sage px-2.5 py-1 text-[11px] font-medium text-paper" data-id="element-232" data-mp="n15igzn3pqo9">
            Bientôt
          </span>}
        {leaving && <span className="absolute left-3 top-3 rounded-full bg-clay px-2.5 py-1 text-[11px] font-medium text-paper" data-id="element-233" data-mp="e0qufsir5xh2">
            Derniers jours
          </span>}
      </div>
      <div className="mt-4 flex flex-1 flex-col" data-id="element-234" data-mp="16ompytwl5jc9">
        <h3 className="font-display text-2xl leading-tight transition-colors duration-150 group-hover:text-clay md:text-[28px]" data-id="element-235" data-mp="16qfx0ab425ks">
          {creator.name}
        </h3>
        <p className="mt-1 text-sm text-muted" data-id="element-236" data-mp="wx8wb2rbfdr1">
          {creator.craft} · {creator.city}
        </p>
        <div className="mt-auto pt-4" data-id="element-237" data-mp="rynvp285is22">
          <div className="mb-2 flex items-center justify-between text-xs" data-id="element-238" data-mp="rxmgclk3rjej">
            <span className={leaving ? 'font-medium text-clay' : 'text-ink'} data-id="element-239" data-mp="1pg5r0v71unbn">{statusLabel(creator)}</span>
            {status === 'current' && pieces > 0 && <span className="text-muted" data-id="element-240" data-mp="3ew89i2vir1rk">{pieces} en ligne</span>}
          </div>
          {status === 'current' && <ExhibitionProgress creator={creator} variant="compact" data-id="element-241" data-mp="3iy3bzap6rl6x" />}
        </div>
      </div>
    </Link>;
}